<template>
  <div class="flex-center position-ref full-height">
    <div class="content">
      <Loading :loading="loading"></Loading>
      <img src="/assets/logos/mayaeduclass.png" alt="" />
      <h3 v-if="this.$route.query.sso && !error">Lütfen bekleyiniz, ilgili platforma yönlendiriliyorsunuz.</h3>
      <SsoError v-if="error" :message="error"></SsoError>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import SsoError from "@/components/SsoError";
import axios from "axios";
import CryptoJS from "crypto-js";

export default {
  name: "MayaEduClass",
  components: {
    Loading,
    SsoError
  },
  data() {
    return {
      loading: false,
      secretKey: 'wv3Bh9PrBswrYLPX2dj9%iE2KeNGCxdmAWFNDuQig3bQTX.refAcavQkaePvVFoh',
      userData: null,
      error: null,
    }
  },
  beforeMount() {
    const query = this.$route.query;
    if (query.sso) {
      this.loading = true
      // gelen data çözülüyor
      const decode = decodeURIComponent(atob(query.sso));
      const bytes = CryptoJS.AES.decrypt(decode, this.secretKey).toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(bytes);
      this.ueslmsCheckUser();
    }
  },
  methods: {
    fail(message) {
      this.loading = false;
      this.error = message;
      console.log('MayaEduClass SSO:', message);
    },

    ueslmsCheckUser() {
      axios.post('https://www.ueslms.com/api/v2/mayaeduclass/user/check', {user: this.userData})
      // axios.post('https://ueslms.test/api/v2/mayaeduclass/user/check', {user: this.userData})
          .then(response => {
            if (response.data.success) {
              this.goMayaEduClass()
            } else if (response.data.message) {
              this.fail(response.data.message)
            } else {
              this.ueslmsCreate()
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    ueslmsCreate() {
      axios.post('https://www.ueslms.com/api/v2/mayaeduclass/user/create', this.userData)
      // axios.post('https://ueslms.test/api/v2/mayaeduclass/user/create', this.userData)
          .then(response => {
            if (response.data.success) {
              this.goMayaEduClass()
            } else {
              this.fail(response.data.message || 'Kullanıcı oluşturulamadı. Lütfen tekrar deneyin.')
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    async goMayaEduClass() {
      const password = (this.userData.role_type === 'student') ? '123456' : 'Ues1234!';

      location.href = "https://www.mayaeduclass.com/#/?username=" + btoa(this.userData.username) + "&password=" + btoa(password);
    },

  }
}
</script>
